module.exports = " <div class=component-view> <loader v-show=loading></loader> <router-view class=view></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View.vue
// module id = 742
// module chunks = 2